<script>
import twButtonsMixin from '@/mixins/twButtonsMixin.js'
import TwButtonBadge from '@/components/generic/tw-button-badge.vue'

export default {
  name: 'TwButton',
  components: { TwButtonBadge },
  mixins: [twButtonsMixin]
}
</script>

<template>
  <component :is="shouldBeComponent" :href="hrefComputed" :target="target" :to="toComputed" :disabled="disabled || loading" :class="twClasses" @click.middle="clickedMiddleButton">
    <svg v-show="loading" :class="loadingClasses" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
      <path class="opacity-85" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>
    <i v-if="!loading && icon && !iconRight" :class="['pi', 'pi-' + icon]" />
    <icon v-else-if="!loading && faIcon && !iconRight" :icon="faIcon" />
    <slot name="default" />
    <tw-button-badge v-if="badge" :size="size" :variant="badgeVariant">
      {{ badge }}
    </tw-button-badge>
    <i v-if="!loading && icon && iconRight" :class="['pi', 'pi-' + icon]" />
  </component>
</template>

<style scoped>

</style>
